import File from '@gef-ui/material-icons/File';
import FileCode from '@gef-ui/material-icons/FileCode';
import FileCsv from '@gef-ui/material-icons/FileCsv';
import FileExcel from '@gef-ui/material-icons/FileExcel';
import FileImage from '@gef-ui/material-icons/FileImage';
import FileLines from '@gef-ui/material-icons/FileLines';
import FileMusic from '@gef-ui/material-icons/FileMusic';
import FilePdf from '@gef-ui/material-icons/FilePdf';
import FilePowerpoint from '@gef-ui/material-icons/FilePowerpoint';
import FileVideo from '@gef-ui/material-icons/FileVideo';
import FileWord from '@gef-ui/material-icons/FileWord';
import FileZipper from '@gef-ui/material-icons/FileZipper';
const applicationFiles = {
    'application/pdf': FilePdf,
    'application/msword': FileWord,
    'application/vnd.ms-word': FileWord,
    'application/vnd.oasis.opendocument.text': FileWord,
    'application/vnd.openxmlformats-officedocument.wordprocessingml': FileWord,
    'application/vnd.ms-excel': FileExcel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml': FileExcel,
    'application/vnd.oasis.opendocument.spreadsheet': FileExcel,
    'application/vnd.ms-powerpoint': FilePowerpoint,
    'application/vnd.openxmlformats-officedocument.presentationml': FilePowerpoint,
    'application/vnd.oasis.opendocument.presentation': FilePowerpoint,
    'text/csv': FileCsv,
    'text/plain': FileLines,
    'text/html': FileCode,
    'application/json': FileCode,
    'application/gzip': FileZipper,
    'application/zip': FileZipper
};
export default ((mimeType)=>{
    if (mimeType.startsWith('image')) {
        return FileImage;
    } else if (mimeType.startsWith('audio')) {
        return FileMusic;
    } else if (mimeType.startsWith('video')) {
        return FileVideo;
    }
    return applicationFiles[mimeType] || File;
});
